import { GET_PLANT_SELECTION } from '../actions/plantSelection/types';

let initialState = {};

export default function (state = initialState, action) {
    switch (action.type) {
        case GET_PLANT_SELECTION:
            return { ...action.payload };
        default:
            return state;
    }
}
